import moment from 'moment';

function utcCalendarDay(year: number, month: number, date: number): moment.Moment {
  return moment.utc([year, month, date]);
}

export function toReportDay(value: any): moment.Moment | null {
  if (!value) {
    return null;
  }

  if (moment.isMoment(value)) {
    return utcCalendarDay(value.year(), value.month(), value.date());
  }

  if (value instanceof Date) {
    return utcCalendarDay(
      value.getFullYear(),
      value.getMonth(),
      value.getDate()
    );
  }

  const parsed = moment.parseZone(value);
  if (!parsed.isValid()) {
    return null;
  }

  return utcCalendarDay(parsed.year(), parsed.month(), parsed.date());
}

export function toReportDayKey(value: any): string | null {
  const day = toReportDay(value);
  return day ? day.format('YYYY-MM-DD') : null;
}

export function toReportDayDate(value: any): Date | undefined {
  const day = toReportDay(value);
  return day ? day.toDate() : undefined;
}

export function toReportDayIso(value: any): string | null {
  const day = toReportDay(value);
  return day ? day.toISOString() : null;
}

export function formatReportDay(value: any): string {
  const day = toReportDay(value);
  return day ? day.format('L') : '';
}
